<ng-template #TooltipContent>
  <div class="tooltip-content">

    <div class="tooltip-header">
      {{'PHONE_NUMBERS.REGISTRATION_REQUIREMENTS' | translate}}:
    </div>

    <div
      *ngFor="let document of documents; let i = index"
      class="tooltip-item"
    >
      {{i + 1}}. {{ 'RESTRICTIONS.' + document | translate: { Default: fallbackDocumentsTranslations[document] } }}
    </div>

  </div>
</ng-template>

<i
  class="material-icons"
  [tooltip]="TooltipContent"
  [theme]="'light'"
  content-type="template"
  placement="bottom"
  width="232"
  max-width="232">
  help_outline
</i>

